module.exports = __webpack_public_path__ + "img/magic-star.f4cc01e1.svg";